module.exports = __webpack_public_path__ + "static/media/mayhem-in-action-forti-selva-art.4f708bd0.png";